import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

// Carousel top slider
const topSliderLength = document.querySelectorAll('.top-slider__item').length;
const topSlider = new Swiper('.top-slider__list', {
  modules: [Navigation, Pagination, Autoplay],
  speed: 750,
  loop: topSliderLength > 1,
  watchOverflow: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".top-slider__pagination",
    bulletClass: 'top-slider__bullet',
    bulletActiveClass: 'top-slider__bullet--active',
    clickable: true,
  },
  navigation: {
    prevEl: '.top-slider__previous',
    nextEl: '.top-slider__next',
    enabled: topSliderLength > 1,
  }
});


function resizeSlider(slider) {
  let wrapper = slider.el;
  let innerWidth = wrapper.parentElement.clientWidth;
  //let navigation = slider.navigation.prevEl.parentElement;

  wrapper.style.margin = '0 ' + (window.innerWidth - innerWidth) / 2 * -1 + 'px';
  wrapper.style.padding = '0 ' + (window.innerWidth - innerWidth) / 2 + 'px';

  let navigation = slider.navigation.prevEl;
  if (navigation !== null) {
    navigation.parentElement.style.maxWidth = innerWidth + 'px';
    navigation.parentElement.style.margin = '0 auto';
  }
}

// Carousel image slider
let bagImageSliders = [];
const imageSliders = document.querySelectorAll('.image-slider');
if (imageSliders.length > 0) {
  imageSliders.forEach((imageSlider) => {
    let list = imageSlider.querySelector('.image-slider__list');
    let length = imageSlider.querySelectorAll('.image-slider__item').length;

    let slider = new Swiper(list, {
      modules: [Navigation, Pagination, Autoplay],
      speed: 750,
      //loop: length > 1,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 12,
      //centeredSlides: true,
      pagination: {
        el: ".image-slider__pagination",
        type: "fraction"
      },
      navigation: {
        prevEl: '.image-slider__previous',
        nextEl: '.image-slider__next',
        enabled: length > 1,
      },
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 12,
          navigation: {
            enabled: true
          }
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            enabled: true
          },
          centeredSlides: false,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 12,
          navigation: {
            enabled: true
          }
        },
      }
    });

    bagImageSliders.push(slider);
    resizeSlider(slider);
  });
}

// Carousel arrangement slider
let bagArrangementsliders = [];
const arrangementSliders = document.querySelectorAll('.arrangement-slider');
if (arrangementSliders.length > 0) {
  arrangementSliders.forEach((arrangementSlider) => {
    let list = arrangementSlider.querySelector('.arrangement-slider__slider');
    let slider = new Swiper(list, {
      modules: [Navigation, Pagination, Autoplay],
      speed: 750,
      loop: false,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
      // autoplay: {
      //   delay: 5000,
      // },
      // pagination: {
      //   el: ".arrangement-slider__pagination",
      //   bulletClass: 'arrangement-slider__bullet',
      //   bulletActiveClass: 'arrangement-slider__bullet--active',
      //   clickable: true,
      // },
      // navigation: {
      //   prevEl: '.arrangement-slider__previous',
      //   nextEl: '.arrangement-slider__next',
      //   enabled: arrangementSliderLength > 1,
      // },
    });

    bagArrangementsliders.push(slider);
    resizeSlider(slider)
  });
}

// const arrangementSliderLength = document.querySelectorAll('.arrangement-slider__slide');
// const arrangementSlider = new Swiper('.arrangement-slider__slider', {
//   modules: [Navigation, Pagination, Autoplay],
//   speed: 750,
//   loop: arrangementSliderLength > 1,
//   watchOverflow: true,
//   slidesPerView: 1,
//   spaceBetween: 10,
//   centeredSlides: false,
//   breakpoints: {
//     576: {
//       slidesPerView: 1,
//       spaceBetween: 24,
//       centeredSlides: false,
//     },
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 24,
//       centeredSlides: false,
//     },
//     992: {
//       slidesPerView: 3,
//       spaceBetween: 24,
//       centeredSlides: false,
//     },
//   },
//   // autoplay: {
//   //   delay: 5000,
//   // },
//   pagination: {
//     el: ".arrangement-slider__pagination",
//     bulletClass: 'arrangement-slider__bullet',
//     bulletActiveClass: 'arrangement-slider__bullet--active',
//     clickable: true,
//   },
//   navigation: {
//     prevEl: '.arrangement-slider__previous',
//     nextEl: '.arrangement-slider__next',
//     enabled: arrangementSliderLength > 1,
//   },
// });

// Carousel location slider
let bagLocationSliders = [];
const locationSliders = document.querySelectorAll('.location-slider');
if (locationSliders.length > 0) {
  locationSliders.forEach((locationSlider) => {
    let list = locationSlider.querySelector('.location-slider__slider');
    // let length = locationSlider.querySelectorAll('.location-slider__slide').length;

    let slider = new Swiper(list, {
      modules: [Navigation, Pagination, Autoplay],
      speed: 750,
      loop: false,
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 12,
      centeredSlides: true,
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
    });

    bagLocationSliders.push(slider);
    resizeSlider(slider)
  });
}

// Handle resize for all sliders
window.addEventListener('resize', () => {
  bagImageSliders.forEach(resizeSlider);
  bagLocationSliders.forEach(resizeSlider);
  bagArrangementsliders.forEach(resizeSlider);
});

// Carousel happy moments
const momentSliderLength = document.querySelectorAll('.happy-moment-slider__slide').length;
const momentSlider = new Swiper('.happy-moment-slider__slider', {
  modules: [Navigation, Pagination, Autoplay],
  speed: 750,
  loop: momentSliderLength > 1,
  watchOverflow: true,
  slidesPerView: 1,
  // autoplay: {
  //   delay: 5000,
  // },
  pagination: {
    el: ".happy-moment-slider__pagination",
    bulletClass: 'happy-moment-slider__bullet',
    bulletActiveClass: 'happy-moment-slider__bullet--active',
    clickable: true,
  },
  navigation: {
    prevEl: '.happy-moment-slider__previous',
    nextEl: '.happy-moment-slider__next',
    enabled: momentSliderLength > 1,
  },
});

const timelineSlider = new Swiper('.timeline-slider', {
  speed: 400,
  loop: true,
  modules: [Navigation, Pagination],
  autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
    bulletActiveClass: 'timeline-slider__bullet--active',
    clickable: true,
    renderBullet: function (index, className) {
      return '<li class="timeline-slider__bullet ' + className + '"><div class="timeline-slider__bullet-line"></div><div class="timeline-slider__bullet-year">' + this.slides[index + 1].dataset.title + '</div></li>';
    },
  },
  on: {
    beforeInit: function () {
      let slides = document.querySelectorAll('.timeline-slider__slide');
      if (slides.length <= 4) {
        this.el.dataset.showMobile = '1';
      }
    }
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

const lieb_card_slider = new Swiper('.lieb-card__slider', {
  modules: [Navigation, Pagination],
  speed: 400,
  loop: false,
  slidesPerView: 1.1,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  breakpoints: {
    992: {
      slidesPerView: 2.1,
      spaceBetween: 24,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3.1,
      spaceBetween: 24,
      centeredSlides: false,
    },
  },
});
